// Season 2026 public pricing — Daily tariff only.
// Internal Weekly+ tier stays out of the public surface by design.
// Source: dataForRent/docs/pricing_season_2026.md

export type ApartmentTypeId = 'studio-sea' | '1br-sea' | '1br-panoramic';

export type PeriodId =
  | 'low-season'
  | 'jun-1h'
  | 'jun-2h'
  | 'jul-1h'
  | 'jul-2h'
  | 'aug'
  | 'sep-1h'
  | 'sep-2h';

export const apartmentTypes: ApartmentTypeId[] = [
  'studio-sea',
  '1br-sea',
  '1br-panoramic',
];

export const periods: PeriodId[] = [
  'low-season',
  'jun-1h',
  'jun-2h',
  'jul-1h',
  'jul-2h',
  'aug',
  'sep-1h',
  'sep-2h',
];

export const HIGH_SEASON_PERIODS: PeriodId[] = [
  'jun-1h', 'jun-2h', 'jul-1h', 'jul-2h', 'aug', 'sep-1h', 'sep-2h',
];

export const LOW_SEASON_PERIODS: PeriodId[] = ['low-season'];

export const prices2026: Record<ApartmentTypeId, Record<PeriodId, number>> = {
  'studio-sea':    { 'low-season': 80,  'jun-1h': 80,  'jun-2h': 90,  'jul-1h': 100, 'jul-2h': 110, 'aug': 120, 'sep-1h': 100, 'sep-2h': 90  },
  '1br-sea':       { 'low-season': 130, 'jun-1h': 130, 'jun-2h': 140, 'jul-1h': 170, 'jul-2h': 180, 'aug': 200, 'sep-1h': 170, 'sep-2h': 140 },
  '1br-panoramic': { 'low-season': 140, 'jun-1h': 140, 'jun-2h': 150, 'jul-1h': 180, 'jul-2h': 190, 'aug': 210, 'sep-1h': 180, 'sep-2h': 150 },
};

export const dlAparthotel2026Aug: Record<ApartmentTypeId, number> = {
  'studio-sea':    165,
  '1br-sea':       271,
  '1br-panoramic': 283,
};

export function roundToNearest(value: number, step: number): number {
  return Math.round(value / step) * step;
}
